import { guid } from '../../../../utils/guid'

import {
  FormItemInvited,
  FormItemActive,
  FormItemTeam,
  FormItemLoggedin,
} from './form-item'

const Filters = {
  addTitle: guid().uid(),
  editTitle: null,
  groups: [],
  formItemsSuggestion: [
    { ...FormItemTeam },
    { ...FormItemInvited },
    { ...FormItemActive },
    { ...FormItemLoggedin },
  ],
}

export default Filters
